import { Link, useUrl } from "@shopify/hydrogen/client";
import NavigationItems from "./navigationItems";
import navigationMenu from "../menu_collections.json";

import {
  NaviconSearch,
  NaviconCart,
  NaviconBars,
  NaviconCross,
  NavPlusIcon,
  NavMinusIcon,
  HeaderWishlistIcon,
  LivLogoAuthorized,
} from "../../elements/Icon";
import { useState } from "react";
import { useWishlist } from "../../../store/modules/client/index";

// comment please remove this
const AvaMobileNav = (props) => {
  const quantity = props.quantity;

  const [clickedTitle, setClickedTitle] = useState("");
  const handleClick = (index) => {
    setClickedTitle(index);
  };

  const { livWishlist } = useWishlist();
  const { pathname } = useUrl();
  return (
    <nav className={`md:hidden block sticky left-0 right-0 top-0 z-[1000] border-[#e5e7eb] border-b-2 h-[50px] ${pathname === "/dashboard" && "hidden"}`}>
      <div className="flex flex-row items-center justify-between w-full h-full gap-4 px-4 bg-white">
        <div className="flex flex-row w-[70px]">
          <div
            className={`flex justify-center items-center h-full ${
              props.showSearchState && "bg-[#B8B8B859]"
            }`}
          >
            <button
              className="relative flex items-center justify-center w-full h-full mx-auto"
              onClick={props.toggleSearch}
            >
              <label
                htmlFor="searchInput"
                className="flex items-center justify-center w-full h-full cursor-pointer"
              >
                <NaviconSearch
                  color={props.showSearchState == true ? "#120A8F" : "#2A3238"}
                />
              </label>
            </button>
          </div>
          <div className="flex items-center justify-center h-full">
            <Link to="/wishlist">
              <div className="relative w-[50px] flex justify-center items-center">
                <HeaderWishlistIcon />
                {livWishlist?.length > 0 && (
                  <span className="flex justify-center items-center bg-[#570054] h-5 w-5 rounded-full text-white absolute right-1 -top-3">
                    {livWishlist?.length}
                  </span>
                )}
              </div>
            </Link>
          </div>
        </div>
        <div className="">
          <Link to="/">
            <LivLogoAuthorized />
          </Link>
        </div>
        <div className="flex flex-row w-[70px] justify-end">
          <div className="items-center justify-center hidden h-full">
            <div className="flex items-center justify-start">
              <div
                onClick={props.toggleCartModal}
                className="relative flex items-center justify-center h-full w-[45px]"
              >
                {quantity > 0 ? (
                  <div className="flex justify-center items-center bg-[#570054] h-5 w-5 rounded-full text-white absolute right-0 -top-3">
                    <p>{quantity}</p>
                  </div>
                ) : (
                  ""
                )}
                <NaviconCart />
              </div>
            </div>
          </div>
          <div className="flex flex-row items-center justify-end gap-4">
            <button
              className="flex items-center justify-center h-full"
              onClick={(e) => props.toggleMobileNav(e)}
            >
              {props.showMobileNavState == false ? (
                <>
                  <NaviconBars size="19px" />
                </>
              ) : (
                <>
                  <NaviconCross color="#120A8F" size="19px" />
                </>
              )}
            </button>
          </div>
        </div>
      </div>

      <div
        className="flex flex-col justify-start items-center fixed text-sm h-screen bg-white bg-opacity-95 w-full transition-all  duration-300 translate-x-[100%]"
        ref={props.mobileNav}
      >
        <div className="flex flex-col items-center justify-start w-full h-auto gap-6 pt-8 pb-20 overflow-y-scroll">
          {navigationMenu.map((collection) => {
            return (
              <div className="w-4/5" key={collection.id}>
                <div
                  onClick={() => {
                    // this sets the the state to true when hover on a specific index, the menu items is in json format
                    if (collection.id === 1) {
                      props.setShowMobileGearsMenu(false);
                      props.setShowMobileBikesMenu(!props.showMobileBikesMenu);
                    }
                    if (collection.id === 2) {
                      props.setShowMobileBikesMenu(false);
                      props.setShowMobileGearsMenu(!props.showMobileGearsMenu);
                    }
                  }}
                >
                  {collection.collections ? (
                    <div className="grid w-full grid-cols-2 overflow-auto ">
                      <div
                        className="uppercase font-gotham-bold text-[#2A3238] w-full"
                        onClick={() => handleClick(collection.id)}
                      >
                        {collection.title}
                      </div>
                      <div
                        className="flex justify-end"
                        onClick={() => handleClick(collection.id)}
                      >
                        {(props.showMobileBikesMenu == true &&
                          collection.id === 1 &&
                          clickedTitle === collection.id) ||
                        (props.showMobileGearsMenu == true &&
                          collection.id === 2 &&
                          clickedTitle === collection.id) ? (
                          <NavMinusIcon />
                        ) : (
                          <NavPlusIcon />
                        )}
                      </div>
                    </div>
                  ) : (
                    <Link
                      onClick={props.toggleMobileNav}
                      to={collection.handle}
                    >
                      <div className="uppercase font-gotham-bold text-[#2A3238] w-full">
                        {collection.title}
                      </div>
                    </Link>
                  )}
                </div>

                {props.showMobileBikesMenu == true &&
                  collection.id === 1 &&
                  clickedTitle === collection.id && (
                    <NavigationItems
                      collections={collection.collections}
                      toggleMobileNav={props.toggleMobileNav}
                    />
                  )}
                {props.showMobileGearsMenu == true &&
                  collection.id === 2 &&
                  clickedTitle === collection.id && (
                    <NavigationItems
                      collections={collection.collections}
                      toggleMobileNav={props.toggleMobileNav}
                    />
                  )}
              </div>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default AvaMobileNav;